
import { vec3 } from "gl-matrix";
import { wMath } from "./wMath.js"

class wGeoSphereBuilder {

	constructor() {

		const X = 0.525731112119133606;
		const Z = 0.850650808352039932;

		this.vdata =
			[vec3.fromValues(-X, 0.0, Z), vec3.fromValues(X, 0.0, Z), vec3.fromValues(-X, 0.0, -Z), vec3.fromValues(X, 0.0, -Z),
			vec3.fromValues(0.0, Z, X), vec3.fromValues(0.0, Z, -X), vec3.fromValues(0.0, -Z, X), vec3.fromValues(0.0, -Z, -X),
			vec3.fromValues(Z, X, 0.0), vec3.fromValues(-Z, X, 0.0), vec3.fromValues(Z, -X, 0.0), vec3.fromValues(-Z, -X, 0.0)];
		this.tindices =
			[[0, 4, 1], [0, 9, 4], [9, 5, 4], [4, 5, 8], [4, 8, 1],
			[8, 10, 1], [8, 3, 10], [5, 3, 8], [5, 2, 3], [2, 7, 3],
			[7, 10, 3], [7, 6, 10], [7, 11, 6], [11, 0, 6], [0, 1, 6],
			[6, 1, 10], [9, 0, 11], [9, 11, 2], [9, 2, 5], [7, 2, 11]]
	};

	subdivideGeosphere(v1, v2, v3, spherePoints, depth) {
		if (depth == 0) {
			spherePoints.push(wMath.vec3Scale(v1, 0.5));
			spherePoints.push(wMath.vec3Scale(v2, 0.5));
			spherePoints.push(wMath.vec3Scale(v3, 0.5));
			return;
		}

		var v12 = vec3.create();
		var v23 = vec3.create();
		var v31 = vec3.create();
		vec3.normalize(v12, wMath.vec3Add(v1, v2));
		vec3.normalize(v23, wMath.vec3Add(v2, v3));
		vec3.normalize(v31, wMath.vec3Add(v3, v1));
		this.subdivideGeosphere(v1, v12, v31, spherePoints, depth - 1);
		this.subdivideGeosphere(v2, v23, v12, spherePoints, depth - 1);
		this.subdivideGeosphere(v3, v31, v23, spherePoints, depth - 1);
		this.subdivideGeosphere(v12, v23, v31, spherePoints, depth - 1);
	}

	buildGeoSphere(numSubDivisions) {
		var vertices = [];
		for (let i = 0; i < 20; i++) {
			this.subdivideGeosphere(this.vdata[this.tindices[i][0]], this.vdata[this.tindices[i][1]], this.vdata[this.tindices[i][2]], vertices, numSubDivisions);
		}
		return vertices;
	}
}

export { wGeoSphereBuilder };